const SELF_LABEL_SUFFIX_REGEX = /\s*\(me\)\s*$/i;

export const readUserText = (...values) => {
    for (const value of values) {
        if (typeof value !== "string") {
            continue;
        }
        const trimmed = value.trim();
        if (trimmed) {
            return trimmed;
        }
    }
    return null;
};

const readUserMediaUrl = (...values) => {
    for (const value of values) {
        const directText = readUserText(value);
        if (directText) {
            return directText;
        }
        const nestedText = readUserText(
            value?.url,
            value?.href,
            value?.imageUrl,
            value?.mediaUrl
        );
        if (nestedText) {
            return nestedText;
        }
    }
    return null;
};

const joinUserNameParts = (user) => readUserText(
    [readUserText(user?.firstName), readUserText(user?.lastName)].filter(Boolean).join(" ")
);

export const resolveUserFullName = (user) => readUserText(
    user?.fullName,
    user?.userFullName,
    user?.profile?.fullName,
    user?.profile?.userFullName,
    user?.user?.fullName,
    user?.user?.userFullName,
    user?.user?.profile?.fullName,
    user?.user?.profile?.userFullName,
    joinUserNameParts(user),
    joinUserNameParts(user?.profile),
    joinUserNameParts(user?.user),
    joinUserNameParts(user?.user?.profile)
);

export const resolveUserUsername = (user) => readUserText(
    user?.username,
    user?.userName,
    user?.profile?.username,
    user?.profile?.userName,
    user?.user?.username,
    user?.user?.userName,
    user?.user?.profile?.username,
    user?.user?.profile?.userName
);

export const resolveUserDisplayName = (user, fallback = null) => readUserText(
    user?.displayName,
    user?.userDisplayName,
    user?.profile?.displayName,
    user?.profile?.userDisplayName,
    user?.profile?.name,
    user?.user?.displayName,
    user?.user?.userDisplayName,
    user?.user?.profile?.displayName,
    user?.user?.profile?.userDisplayName,
    user?.user?.profile?.name,
    user?.name,
    user?.user?.name,
    resolveUserUsername(user),
    resolveUserFullName(user),
    fallback
);

export const resolveUserAvatarUrl = (user) => readUserMediaUrl(
    user?.userAvatarUrl,
    user?.avatarUrl,
    user?.profilePicture,
    user?.avatar,
    user?.profile?.avatarUrl,
    user?.profile?.profilePicture,
    user?.profile?.avatar,
    user?.user?.avatarUrl,
    user?.user?.profilePicture,
    user?.user?.avatar,
    user?.user?.profile?.avatarUrl,
    user?.user?.profile?.profilePicture,
    user?.user?.profile?.avatar
);

export const resolveSelfDisplayName = (user, fallback = "You") => {
    const base = readUserText(
        resolveUserDisplayName(user),
        fallback
    ) || fallback;
    const normalizedBase = base.replace(SELF_LABEL_SUFFIX_REGEX, "").trim() || fallback;
    return `${normalizedBase} (me)`;
};

export const matchesUserIdentityQuery = (user, query) => {
    const normalizedQuery = readUserText(query)?.toLowerCase();
    if (!normalizedQuery) {
        return true;
    }
    return [
        resolveUserDisplayName(user),
        resolveUserUsername(user),
        resolveUserFullName(user),
    ]
        .filter(Boolean)
        .some((value) => value.toLowerCase().includes(normalizedQuery));
};
